// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'home';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M2.815 10.458v6.188h4.5v-4.5A1.125 1.125 0 0 1 8.44 11.02h1.125a1.125 1.125 0 0 1 1.125 1.125v4.5h4.5v-6.187M.565 9.333l7.641-7.642a1.125 1.125 0 0 1 1.592 0l7.642 7.642'
  />
);

export const viewBox = '0 0 18 18';
